export default class Toash {
    constructor(id) {
        let toashEl;
        if (typeof selector === 'string') {
            toashEl = document.getElementById(id);
        } else if (toashEl) {
            toashEl = toashEl;
        } else {
            toashEl = document.createElement('div');
            toashEl.id = id;
            toashEl.classList.add('vl-toash');
            document.body.append(toashEl);
        }
        this.toashEl = toashEl;
    }

    show = (content, type = '', ttl = '', callback = function(e) {}) => {
        let result, toashItemEl, toashTtlEl, toashContentEl;
        toashItemEl = document.createElement('div');
        toashItemEl.classList.add('init');
        if (ttl != '') {
            toashTtlEl = document.createElement('div');
            toashTtlEl.classList.add('vl-toash__ttl');
            toashTtlEl.textContent = ttl;
            toashItemEl.appendChild(toashTtlEl);
        }
        if (content != '') {
            toashContentEl = document.createElement('div');
            toashContentEl.classList.add('vl-toash__content');
            toashContentEl.textContent = content;
            toashItemEl.appendChild(toashContentEl);
        }
        if (type != '') {
            toashItemEl.classList.add('vl-toash__item--' + type, 'jsToash');
        } else {
            toashItemEl.classList.add('vl-toash__item', 'jsToash');
        }
        this.toashEl.appendChild(toashItemEl);
        this.index++;
        setTimeout(() => {
            toashItemEl.classList.add('show');
        }, 1);
        setTimeout(() => {
            toashItemEl.classList.remove('show');
            setTimeout(() => {
                toashItemEl.remove();
            }, 250);
        }, 5000);
        result = this.toashEl;
        callback(result);
    }
}